import { render } from "./CurrentProc.vue?vue&type=template&id=c7de0a70&scoped=true"
import script from "./CurrentProc.vue?vue&type=script&lang=js"
export * from "./CurrentProc.vue?vue&type=script&lang=js"

import "./CurrentProc.vue?vue&type=style&index=0&id=c7de0a70&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7de0a70"]])

export default __exports__